import { createContext } from 'react';

export type ConfigureScenarioContextType = {
  mode: 'guest' | 'authorized';
  workspaceId: string;
  teamId: string;
  challengeAFlow: (teamId: string, workspaceId: string) => string;
  challengeSimulation: (
    teamId: string,
    workspaceId: string,
    scenarioId: string,
    reviewId: string
  ) => string;
};

export const ConfigureScenarioContext =
  createContext<ConfigureScenarioContextType>({
    mode: 'guest',
    workspaceId: '',
    teamId: '',
    challengeAFlow: (teamId: string, workspaceId: string) => '',
    challengeSimulation: (
      teamId: string,
      workspaceId: string,
      scenarioId: string,
      reviewId: string
    ) => '',
  });
